













































































































































































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import roles from "@/config/wow/roles";


/**
 * Components
 */
import CharacterCategory from "@/components/_global/CharacterCategory.vue";
import DropArea from "@/components/_global/DropArea.vue";
import DragItem from "@/components/_global/DragItem.vue";
import CharacterLabel from "@/components/_global/CharacterLabel.vue";


/**
 * Group card component.
 */
@Component({
	components: {
		CharacterLabel,
		CharacterCategory,
		DropArea,
		DragItem
	}
})
export default class GroupCard extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	roles = roles;

	/// Properties

	// Identifier
	@Prop({default: ""})
	index!: string;

	@Prop()
	title!: string;

	@Prop({default: "center"})
	titleAlignment!: string;

	@Prop()
	titleImageSrc!: string | null;

	@Prop()
	titleRightIcon!: string | null;

	@Prop({default: () => []})
	data!: any[];

	@Prop({default: () => []})
	observedData!: any[];

	@Prop({type: Boolean})
	isInteractive!: boolean;

	@Prop({type: Boolean})
	isSource!: boolean;

	@Prop({type: Boolean})
	displayILvl!: boolean;

	@Prop({type: Boolean})
	displayTotalILvl!: boolean;

	@Prop({type: Boolean})
	displayPlayerCount!: boolean;

	@Prop()
	colorPlayerCount!: (playerCount: number) => string;

	@Prop()
	onEditTitle!: (newTitle: string) => void;

	// Label properties
	@Prop({default: 2})
	labelSize!: number;

	@Prop()
	labelBackgroundColor!: (character: any) => string;

	@Prop()
	labelRightIcon!: (character: any) => string;

	@Prop()
	labelRightIconColor!: (character: any) => string;

	@Prop()
	labelContent!: (character: any) => string;


	/// Attributes
	isTitleEditing = false;
	titleEdition: string | null = null;

	get getIlvl() {
		const data = this.data;
		return this.getIlvlForData(data);
	}

	get playerCount() {
		return this.data.length;
	}

	/// Methods
	getIlvlForData(data: any[]) {
		const sum = data.reduce(function (a, b) {
			return a + (b.averageItemLevelEquipped ? b.averageItemLevelEquipped : 0);
		}, 0);
		return data.length > 0 ? (sum / data.length).toFixed(2) : 0;
	}

	get organizedData(): any {
		return roles.reduce((o, key) => ({
			...o,
			[key.name]: this.sortData(this.data.filter(x => x.role === key.name).map(x => ({
				...x,
				isUsed: this.observedData.find((od) => {
					return od.id === x.id;
				}) != null
			})))
		}), {});
	}

	sortData(data: any[]) {
		return data.sort((a, b) => {
			return a.class - b.class || ((a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0);
		});
	}


	// Title edition
	handleStartEditTitle() {
		this.isTitleEditing = !this.isTitleEditing;
		this.titleEdition = this.title;
	}

	handleEditTitleFocus(event: any) {
		event.target.select();
	}

	handleEndEditTitle() {
		if (!this.titleEdition) {
			this.titleEdition = this.title;
		}
		this.isTitleEditing = !this.isTitleEditing;
		this.onEditTitle(this.titleEdition);
	}

	// Drag & Drop
	handleDrop(itemDropped: DragItem, role: string) {
		const characterDropped = itemDropped.data;
		if (itemDropped.isCopyable) {
			this.$emit("on-copy", characterDropped, this.index, role);
		}
		else {
			this.$emit("on-move", characterDropped, itemDropped.parentIndex, this.index, role);
		}
	}

	handleLabelDrop(character: any, parentIndex: any) {
		if (!this.isSource) {
			this.$emit("on-delete", character, parentIndex);
		}
	}

	handleCharacterLabelDoubleClick(character: any, role: string) {
		if (!this.isSource) {
			this.$emit("on-delete", character, this.index);
		}
		else {
			this.$emit("on-copy", character, null, role);
		}
	}

	handleCharacterLabelContextMenu(character: any, ev: any) {
		this.$emit("on-character-context", character, this.index, ev);
	}
}
